export default {
     data: () => ({
        stepper: 0,
        steps: [
        {
            label: 'Basic Info',
            completed: false,
        },{
            label: 'Login Details',
            completed: false,
        },{
            label: 'Create Project',
            completed: false,
        }]
    })
}
